import { send } from '../../../../../../src/network';
import { type CustomerFavorites } from '../../../../../../src/types/CustomerFavorites';
export { type CustomerFavorites } from '../../../../../../src/types/CustomerFavorites';

export async function getFavoritePairings() {
  return await send<CustomerFavorites>({
    path: '/api/v2/customers/self/favorite_pairings/',
    method: 'GET',
  });
}
